import React from 'react'
import { goTop } from '../../helpers/goTop'
import "./Footer.css"

const Footer = () => {
  return (
    <footer className='footer-container '>
      <div className='container'>
        <figure onClick={() => goTop("smooth")} className='footer-container_logo'>
          <img src='/logo.ico' alt='Logo' />
        </figure>

        <div className='footer-column footer-container_contact_item'>
          <div className='footer-column'>
            <div className='column-content'>
              <h2>Specials</h2>
              <ul>

                <li>
                  <a href='#'>
                    <span>
                      <i className=''></i>
                    </span>
                    AvilMilks
                  </a>
                </li>
                <li>
                  <a href='#'>
                    <span>
                      <i className=''></i>
                    </span>
                    Smoothies
                  </a>
                </li>
                <li>
                  <a href='#'>
                    <span>
                      <i className=''></i>
                    </span>
                    Shakes
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className='footer-column'>
            <div className='column-content'>
              <h2>About Us</h2>
              <ul>
                <li>
                  <a href='#'>
                    <span>
                      <i className=''></i>
                    </span>
                    Our Story
                  </a>
                </li>
                <li>
                  <a href='#'>
                    <span>
                      <i className=''></i>
                    </span>
                    Gallary
                  </a>
                </li>
                <li>
                  <a href='#'>
                    <span>
                      <i className=''></i>
                    </span>
                    Reviews
                  </a>
                </li>
              </ul>
            </div>
          </div>


          <div className='footer-column'>
            <div className='column-content'>
              <h2>Company</h2>
              <ul>

                <li>
                  <a href='#'>
                    <span>
                      <i className=''></i>
                    </span>
                    Press
                  </a>
                </li>
                <li>
                  <a href='#'>
                    <span>
                      <i className=''></i>
                    </span>
                    Contact
                  </a>
                </li>
                <li>
                  <a href='#'>
                    <span>
                      <i className=''></i>
                    </span>
                    Careers
                  </a>
                </li>
              </ul>
            </div>
          </div>


        </div>
        <div className='footer-container_social-media'>
          <a title='WhatsApp' href="https://wa.me/qr/YSFWZT3PY6VBM1/" target="_blank" rel="noopener noreferrer" >
            <img src='/iconos/footer/whatsapp.svg' alt='WhatsApp' />
          </a>
          <a title='Facebook' href="https://www.facebook.com/pages/VH-Cool-Bar-Avil-Milk/358894437498023" target="_blank" rel="noopener noreferrer">
            <img src='/iconos/footer/facebook.svg' alt='Facebook' />
          </a>
          <a title='Instagram' href="https://www.instagram.com/kottakkal_vh_avilmilk/" target="_blank" rel="noopener noreferrer">
            <img src='/iconos/footer/instagram.svg' alt='Instagram' />
          </a>
        </div>
      </div>
    </footer >
  )
}

export default Footer